import React, { useEffect, useState } from 'react'
import { Link } from 'react-scroll';

const Slider = () => {
    useEffect(()=>{
        randomNumberInRange()
    },[])
    const [num, setNum] = useState(null)
 
    const randomNumberInRange = () => {
        let number =  Math.floor(Math.random()
            * (3 - 0 + 1)) + 0
        setNum(number);
    };
 
  return (
    <div className='w-[100%] h-auto bg-white flex flex-col justify-center items-center px-[50px] md:px-[200px]  py-[60px] md:py-[180px] text-center'>
        
        
        {num == 0  && (
            <>
             <h1 className='text-[30px] md:text-[38px] font-bold mb-[15px] leading-10 md:leading-normal'>Navigate to safety with our expertise</h1>
             <button className='text-[15px] md:text-[24px] bg-gradient-to-l from-green-400 to-lime-800 bg-clip-text text-transparent'>Get App</button>
             </>

        )}
        {num == 1  && (
              <>
             <h1 className='text-[30px] md:text-[38px] font-bold mb-[15px] leading-10 md:leading-normal'>Learn to drive with assurance and competence</h1>
             <Link to="waitlist" smooth={true} duration={500}>
             <button className='text-[15px] md:text-[24px] bg-gradient-to-l from-green-400 to-lime-800 bg-clip-text text-transparent'>Join Our waitlist</button>
             </Link>
             </>

        )}
        {num == 2  && (
             <>
            <h1 className='text-[30px] md:text-[38px] font-bold mb-[15px] leading-10 md:leading-normal'>Let us steer your journey on the road to safety</h1>
            <Link to="why" smooth={true} duration={500}>
            <button className='text-[15px] md:text-[24px] bg-gradient-to-l from-green-400 to-lime-800 bg-clip-text text-transparent'>Why we exist</button>
            </Link>
           </>

        )}
        {num == 3  && (
             <>
            <h1 className='text-[30px] md:text-[38px] font-bold mb-[15px] leading-10 md:leading-normal'>Drive your future with competence</h1>
            <Link to="waitlist" smooth={true} duration={500}>
             <button className='text-[15px] md:text-[24px] bg-gradient-to-l from-green-400 to-lime-800 bg-clip-text text-transparent'>Join Our waitlist</button>
             </Link>
            </>

        )}
       
      

       

       

       

      
    </div>
  )
}

export default Slider
